<footer class="footer">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul>
                <li>
                    <a href="#">
                        Home
                    </a>
                </li>
                <li>
                    <a href="#">
                        Company
                    </a>
                </li>
                <li>
                    <a href="#">
                        Portfolio
                    </a>
                </li>
                <li>
                    <a href="#">
                        Blog
                    </a>
                </li>
            </ul>
        </nav>
        <!--http://www.creative-tim.com-->
        <p class="copyright pull-right">
            &copy; {{test | date: 'yyyy'}} <a href="">Creative Tim</a>, made with love for a better web
        </p>
    </div>
</footer>
